import { mediaQueries } from '@centivo/react-components'
import styled, { css } from 'styled-components'

import { responsiveStyles } from '_helpers/styles'

export const Nav = styled.nav<{ isPrivateRoute?: boolean }>`
  display: flex;
  justify-content: space-around;
  padding: 1.875rem 1rem;
  padding-bottom: initial;
  height: 6.25rem;
  margin: auto;
  ${({ isPrivateRoute }) =>
    !isPrivateRoute &&
    css`
      margin-top: 5.25rem;
      margin-bottom: 2rem;
    `}
  z-index: 20;

  ${responsiveStyles}

  @media ${mediaQueries.mobile} {
    position: sticky;
    justify-content: space-between;
    top: 1.25rem;
  }
`
